import * as types from '../mutation-types'
import Auth from '../../resource/auth'
const state = {
  user: {},
  authorized: false,
  viewType: 1
}

const getters = {
  loginUser: state => state.user,
  authorized: state => state.authorized,
  viewType: state => state.viewType
}

const actions = {
  getSession: function ({
    commit
  }) {
    Auth.session({}).then(res => {
      let data = res.body
      let user = null
      if (data.code === 0) {
        user = data.result
      }
      commit(types.LOAD_SESSION, user)
    }, res => {
      commit(types.LOAD_SESSION, null)
      alert('服务器繁忙，请稍后再重试注册(╯﹏╰）!!!\n有人要扣钱了(>﹏<)！！！')
    })
  },
  loadSession: function ({
    commit
  }, session) {
    commit(types.LOAD_SESSION, session)
  },
  setViewType: function ({
    commit
  }, viewType) {
    commit(types.SET_VIEW_TYPE, viewType)
  },
  clear: function ({
    commit
  }) {
    commit(types.LOAD_SESSION, {})
  },
  setUserProperty: function ({
    commit
  }, prop, val) {
    commit(types.SET_USER_PROPERTY, prop, val)
  }
}

const mutations = {
  [types.LOAD_SESSION] (state, user) {
    state.user = user
    if (user && user._id) {
      state.authorized = true
    } else {
      state.authorized = false
    }
  },
  [types.SET_VIEW_TYPE] (state, viewType) {
    state.viewType = viewType
  },
  [types.SET_USER_PROPERTY] (state, prop, val) {
    if (state.user) {
      state.user[prop] = val
    }
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js